import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { OcNumberArea } from "./Styles";

export default function OC({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="OC"
            value={!value ? document.documents.oc.number : value}
          />
        </div>
      ) : (
        <OcNumberArea>
          <Informative
            readonly={true}
            label="OC"
            value={!value ? document.documents.oc.number : value}
          />
        </OcNumberArea>
      )}
    </>
  );
}
